const translation: Record<string, string> = {
  "app.name": "黑料曝光",
  "app.tagline": "真实内幕全收录",
  "nav.home": "首页",
  "nav.about": "关于我们",
  "common.read": "阅读",
  "common.published": "发布",
};

export default translation;